import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            平台优势
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            为什么追剧达人们都选被窝影院
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group p-6 md:p-7 rounded-xl bg-background-50 border border-background-200/70 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-500 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="mt-5 text-base md:text-lg font-heading font-bold text-foreground-900">
                {item.title}
              </h3>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}